import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Button, makeStyles, SvgIcon } from '@material-ui/core';
import PropTypes from 'prop-types';
import AffordableIcon from '../../../../icons/affordable.svg';
import DecreasingNeedIcon from '../../../../icons/decreasingNeed.svg';
import FastIcon from '../../../../icons/fast.svg';
import EasyIcon from '../../../../icons/easy.svg';
import { GoogleCaptcha } from "../../Common/SubComponents/GoogleCaptcha";

const useStyles = makeStyles(theme => ({
  textcolor: {
    color: theme.palette.primary.main,
  },
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16 !important`,
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.161)',
  }
}));

const categories = [
  {
    icon: EasyIcon,
    title: "Easy",
    description: "No Medical Exam",
  },
  {
    icon: AffordableIcon,
    title: "Affordable",
    description: "Competitive Prices",
  },
  {
    icon: FastIcon,
    title: "Fast",
    description: "Coverage in 15 Minutes",
  },
  {
    icon: DecreasingNeedIcon,
    title: "Decreasing",
    description: "Coverage Matches Insurance Needs",
  },
];

export default function GettingStarted(props) {
  const classes = useStyles();
  const skipCaptcha = process.env.REACT_APP_DISABLE_CAPTCHA === 'true';

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const [validCaptcha, setValidCaptcha] = useState(skipCaptcha ? true : null);

  const handleCaptchaChange = (responseToken) => {
    if (responseToken) {
      setValidCaptcha(true);
    }
  };

  const submitForm = () => {
    if (validCaptcha) {
        props.onNext();
    } else {
      setValidCaptcha(false);
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col lg={9} className="getting-started-div">
          <Row className="heroImage" />
          <Row className="text-center category">
            {categories.map((item, index) =>
              <Col className="category-item" key={index}>
                <div className="category-icon mb-2">
                  <SvgIcon component={item.icon} color="primary" />
                </div>
                <div className="category-text">
                  <h6 className="mb-0 category-title">{item.title}</h6>
                  <p className="category-desc">{item.description}</p>
                </div>
              </Col>
            )}
          </Row>
          <Row className="text-center mt-3 mb-2">
            <Col>
              <h3>Relax. We've got you covered.</h3>
              <p className="category-desc">Here's what to expect from your<span className={classes.textcolor}> DECREASING TERM </span> process</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col className="col-auto steps-section">
              <div className={`steps-container ${classes.lightBackground}`}>
                <div className="step m-0">
                  <div><span className={`step-number ${classes.textcolor}`}>1</span></div>
                  <div className="step-text">Provide basic personal information</div>
                </div>
                <div className="step">
                  <div><span className={`step-number ${classes.textcolor}`}>2</span></div>
                  <div className="step-text">Review your personalized offer with no obligation</div>
                </div>
                <div className="step m-0">
                  <div><span className={`step-number ${classes.textcolor}`}>3</span></div>
                  <div className="step-text">Accept offer and purchase your policy</div>
                </div>
              </div>
            </Col>
          </Row>

          {!skipCaptcha ? (
            <Row className="justify-content-center mt-3">
              <GoogleCaptcha handleCaptchaChange={handleCaptchaChange} showError={validCaptcha === false} />
            </Row>
          ) : (
            <Row className="justify-content-center border mt-2 mb-2">
              <span className="text-black-50 mt-2 mb-2">CAPTCHA Disabled By Config</span>
            </Row>
          )}

          <Row className="justify-content-center pb-1 mt-3">
            <span><h6 className='mb-0'><b>Ready? Let's get started.</b></h6></span>
          </Row>
          <Row className="justify-content-center mt-3 mb-3">
            <Col className="col-auto">
              <Button variant="contained" color="primary" onClick={submitForm} >GET STARTED</Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

GettingStarted.propTypes = {
  onNext: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/GettingStarted.js